<template>
    <div class="page-wrapper flex margin-left-sm">
        <div class="flex flex-direction flex-treble">
            <div class="flex align-center justify-between bg-white radius padding">
                <div class="count flex flex-direction align-center justify-center bg-blue radius">
                    <div class="number text-white text-bold">{{ count.proAll }}</div>
                    <div class="text-lg text-white margin-top">参与项目数量/个</div>
                </div>
                <div class="count flex flex-direction align-center justify-center bg-blue light radius">
                    <div class="number text-white text-bold">{{ count.underway }}</div>
                    <div class="text-lg text-white margin-top">进行中任务/个</div>
                </div>
                <div class="count flex flex-direction align-center justify-center bg-yellow light  radius">
                    <div class="number text-white text-bold">{{ count.toReview }}</div>
                    <div class="text-lg text-white margin-top">待评审/个</div>
                </div>
                <div class="count flex flex-direction align-center justify-center bg-red radius">
                    <div class="number text-white text-bold">{{ count.reject }}</div>
                    <div class="text-lg text-white margin-top">逾期/驳回/个</div>
                </div>
                <div class="count flex flex-direction align-center justify-center bg-green radius">
                    <div class="number text-white text-bold">{{ count.proCheckCount }}</div>
                    <div class="text-lg text-white margin-top">项目结项/个</div>
                </div>
            </div>
            <div class="flex-sub flex margin-top-sm">
                <div class="flex flex-direction flex-sub bg-white radius padding-lr-sm padding-tb">
                    <div class="text-df text-black">新任务</div>
                    <div v-for="(item,index) in new_pro" :key="index" class="new-item flex flex-direction justify-center">
                        <div class="text-sm text-black text-bold cursor" @click="showApply(item)" v-if="item.type === 'msg'">{{ item.name }}</div>
                        <div class="text-sm text-black text-bold cursor" @click="showTask(item)" v-else>{{ item.pro_name }}</div>
                        <div class="flex align-center text-xs text-dg margin-top-sm">
                            <div :class="item.end_day | end_day_color">{{ item.create_time }}<span class="margin-left-xs">{{item.end_day | end_day}}</span></div>
                            <div class="margin-left-sm">{{ item.member_name }}</div>
                        </div>
                    </div>
                    <empty v-if="!new_pro.length" class="self-center"  size="min"></empty>
                </div>
                <div class="flex flex-direction flex-sub bg-white radius padding-lr-sm padding-tb margin-left-sm">
                    <div class="text-df text-black margin-bottom">今日工作</div>
                    <div v-for="(item,index) in day_pro" :key="index" class="flex align-center justify-between margin-bottom">
                        <div class="text-sm text-black text-bold cursor" @click="finishTask(item)">{{ item.pro_name }}</div>
                        <div class="text-xs" :class="item.end_day | end_day_color">{{ item.create_time }}<span class="margin-left-xs">{{item.end_day | end_day}}</span></div>
                    </div>
                    <el-divider v-if="day_pro.length"></el-divider>
                    <empty v-else class="self-center" size="min"></empty>
                    <div class="text-df text-black margin-tb">未来三天工作</div>
                    <div v-for="(item,index) in three_pro" :key="index" class="flex align-center justify-between margin-bottom">
                        <div class="text-sm text-black text-bold cursor" @click="finishTask(item)">{{ item.pro_name }}</div>
                        <div class="text-xs" :class="item.end_day | end_day_color">{{ item.create_time }}<span class="margin-left-xs">{{item.end_day | end_day}}</span></div>
                    </div>
                    <el-divider v-if="three_pro.length"></el-divider>
                    <empty v-else class="self-center" size="min"></empty>
                    <div class="text-df text-black margin-tb">未来一周工作</div>
                    <div v-for="(item,index) in week_pro" :key="index" class="flex align-center justify-between margin-bottom">
                        <div class="text-sm text-black text-bold cursor" @click="finishTask(item)">{{ item.pro_name }}</div>
                        <div class="text-xs" :class="item.end_day | end_day_color">{{ item.create_time }}<span class="margin-left-xs">{{item.end_day | end_day}}</span></div>
                    </div>
                    <el-divider v-if="week_pro.length"></el-divider>
                    <empty v-else class="self-center" size="min"></empty>
                </div>
            </div>
        </div>
        <div class="report-container flex flex-direction flex-shrink bg-white radius padding-lr-sm padding-tb margin-left-sm">
            <div class="text-df text-black">汇报提醒</div>
            <router-link :to="`/web/staff/project/report/${item.pid}/${item.p_name}`" v-for="(item,index) in report_remind" :key="index" class="report-item flex flex-direction justify-center padding-lr-sm margin-top-sm">
                <div class="text-xs text-black text-bold" @click="showTask(item)">{{ item.title }}</div>
                <div class="flex align-center text-xs text-dg margin-top-xs">
                    <div :class="item.end_day | end_day_color">{{ item.r_time }}<span class="margin-left-xs">{{item.end_day | end_day}}</span></div>
                </div>
            </router-link>
            <empty v-if="!report_remind.length" class="self-center"  size="min"></empty>
        </div>
        <task-finish-dialog :dialog-visible="finishTaskDialog" :tid="cur_task_id"  @watchState="watchState"></task-finish-dialog>
        <task-detail-task-dialog :dialog-visible="addTaskDetailDialog" :readonly="false" :tid="cur_task_id" @watchDetailState="watchDetailState"></task-detail-task-dialog>
    </div>
</template>

<script>

import {getProjectCountInfo, getUserProList} from "@/api";
import TaskDetailTaskDialog from "@/views/web/staff/components/TaskDetailTaskDialog";
import TaskFinishDialog from "@/views/web/staff/components/TaskFinishDialog";

export default {
    name: "project-remind",
    components: {TaskFinishDialog, TaskDetailTaskDialog},
    data() {
        return {
            start_time: '',
            end_time: '',
            count: '',
            new_pro: [],
            day_pro: [],
            three_pro: [],
            week_pro: [],
            report_remind: [],
            cur_task_id: 0,
            finishTaskDialog:false,
            addTaskDetailDialog: false,
        }
    },
    created() {
        this.$emit('setIndex', [-1,0], '提醒', true)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            let _data = await getProjectCountInfo()
            this.count = _data.data
            _data = await getUserProList()
            this.new_pro = _data.data.new_pro
            this.day_pro = _data.data.day_pro
            this.three_pro = _data.data.three_pro
            this.week_pro = _data.data.week_pro
            this.report_remind = _data.data.report_remind

        },
        showApply(data) {
            this.$router.replace(`/web/admin/apply/review/${data.p_id}`)
        },
        showTask(data) {
            this.cur_task_id = data.id
            this.addTaskDetailDialog = true
        },
        finishTask(data){
            this.cur_task_id = data.id
            this.finishTaskDialog = true
        },
        watchState(data) {
            if (data) this.init()
            this.cur_task_id = 0
            this.finishTaskDialog = false
        },
        watchDetailState(data) {
            this.init()
            if (!data) {
                this.cur_task_id = 0
                this.addTaskDetailDialog = false;
            }
        },
    },
    filters:{
        end_day(val){
            if (val===0){
                return '今天截止'
            }else if (val === 1) {
                return `明天截止`
            }else if (val < 0) {
                return `已逾期${Math.abs(val)}天`
            }else {
                if (Number(val)) {
                    return `还有${Math.abs(val)}天截止`;
                } else {
                    return `还有${val}小时截止`;
                }

            }
        },
        end_day_color(val){
            if (val===0){
                return `text-dg`
            }else if (val === 1) {
                return `text-dg`
            }else if (val < 0) {
                return `text-red`
            }else {
                return `text-dg`
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .count {
        width: 221px;
        height: 160px;

        .number {
            font-size: 50px;
        }
    }
    .report-container{
        width: 368px;
        .report-item{
            height: 80px;
            background-color: #ffffff;
            box-shadow: 0px 0px 13px 0px
            rgba(109, 109, 109, 0.09);
            border-radius: 10px;
        }

    }

    .new-item {
        height: 108px;
        border-bottom: 1px solid #e6e6e6;
    }
}
</style>
